import { createSlice } from "@reduxjs/toolkit";
import {
  cancelRenewal,
  fetchQuotePdf,
  fetchRenewalForm,
  searchRenewals,
  sendRenewalEmail,
  updateRenewalCoverageDate,
  updateRenewalCustomerCode,
  updateRenewalStatus,
} from "./renewalsSearchThunks";

const initialState = {
  isLoading: false,
  data: [],
  viewRenewal: {
    isCancelling: false,
    isSendingEmail: false,
    isLoading: false,
    data: [],
  },
  quotePdf: {
    isLoading: false,
    url: null,
    error: null,
  },
};

export const renewalsSearch = createSlice({
  name: "renewalsSearch",
  initialState,
  reducers: {
    clearQuotePdf: {
      reducer(state) {
        if (state.quotePdf.url) URL.revokeObjectURL(state.quotePdf.url);
        state.quotePdf.isLoading = false;
        state.quotePdf.url = null;
        state.quotePdf.error = null;
      },
    },
    clearRenewalsSearch: {
      reducer(state) {
        state.isLoading = false;
        state.data = [];
      },
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(searchRenewals.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(searchRenewals.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.data = payload;
      })
      .addCase(searchRenewals.rejected, (state) => {
        state.isLoading = false;
        state.data = [];
      })
      .addCase(fetchRenewalForm.pending, (state) => {
        state.viewRenewal.isLoading = true;
      })
      .addCase(fetchRenewalForm.fulfilled, (state, { payload }) => {
        state.viewRenewal.isSendingEmail = false;
        state.viewRenewal.isCancelling = false;
        state.viewRenewal.isLoading = false;
        state.viewRenewal.data = payload;
      })
      .addCase(fetchRenewalForm.rejected, (state) => {
        state.viewRenewal.isLoading = false;
        state.viewRenewal.data = null;
      })
      .addCase(sendRenewalEmail.pending, (state) => {
        state.viewRenewal.isSendingEmail = true;
      })
      .addCase(sendRenewalEmail.rejected, (state) => {
        state.viewRenewal.isSendingEmail = false;
      })
      .addCase(sendRenewalEmail.fulfilled, (state, { payload }) => {
        state.viewRenewal.data.status = payload.status;
        state.viewRenewal.data.sent_at = payload.sent_at;
        state.viewRenewal.data.sent_subject = payload.sent_subject;
        state.viewRenewal.data.sent_body = payload.sent_body;
        state.viewRenewal.data.last_updated_at = payload.last_updated_at;
        state.viewRenewal.data.last_updated_by = payload.last_updated_by;
        state.viewRenewal.isSendingEmail = false;
      })
      .addCase(cancelRenewal.pending, (state) => {
        state.viewRenewal.data.isCancelling = true;
      })
      .addCase(cancelRenewal.rejected, (state) => {
        state.viewRenewal.data.isCancelling = false;
      })
      .addCase(cancelRenewal.fulfilled, (state, { payload }) => {
        state.viewRenewal.data.status = payload.status;
        state.viewRenewal.data.cancellation_reason =
          payload.cancellation_reason;
        state.viewRenewal.data.isCancelling = false;
        state.viewRenewal.data.last_updated_at = payload.last_updated_at;
        state.viewRenewal.data.last_updated_by = payload.last_updated_by;
      })
      .addCase(updateRenewalCustomerCode.fulfilled, (state, { payload }) => {
        state.viewRenewal.data.customer_code = payload.customer_code;
        state.viewRenewal.data.last_updated_at = payload.last_updated_at;
        state.viewRenewal.data.last_updated_by = payload.last_updated_by;
      })
      .addCase(updateRenewalCoverageDate.fulfilled, (state, { payload }) => {
        state.viewRenewal.data.coverage_date = payload.coverage_date;
        state.viewRenewal.data.last_updated_at = payload.last_updated_at;
        state.viewRenewal.data.last_updated_by = payload.last_updated_by;
      })
      .addCase(updateRenewalStatus.fulfilled, (state, { payload }) => {
        state.viewRenewal.data.status = payload.status;
        state.viewRenewal.data.last_updated_at = payload.last_updated_at;
        state.viewRenewal.data.last_updated_by = payload.last_updated_by;
      })
      .addCase(fetchQuotePdf.pending, (state) => {
        state.quotePdf.isLoading = true;
        state.quotePdf.error = null;
      })
      .addCase(fetchQuotePdf.rejected, (state, { payload }) => {
        state.quotePdf.isLoading = false;
        state.quotePdf.error = payload || "Unexpected error";
      })
      .addCase(fetchQuotePdf.fulfilled, (state, { payload }) => {
        state.quotePdf.isLoading = false;
        state.quotePdf.url = payload;
      });
  },
});

export const { clearRenewalsSearch, clearQuotePdf } = renewalsSearch.actions;

export default renewalsSearch.reducer;
